export default __webpack_public_path__ + "static/Screenshot6-dd99dce346701e512a3c6600433f4284.jpg";